import { render, staticRenderFns } from "./Gate.vue?vue&type=template&id=6223deac&scoped=true"
import script from "./Gate.vue?vue&type=script&lang=js"
export * from "./Gate.vue?vue&type=script&lang=js"
import style0 from "./Gate.vue?vue&type=style&index=0&id=6223deac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6223deac",
  null
  
)

export default component.exports